<!--
 * @Author: jackshen
 * @Date: 2021-07-08 15:56:38
 * @LastEditors: wenlin
 * @LastEditTime: 2021-07-08 18:35:31
 * @Description:
-->
<template>
  <div class="case_detail">
    <el-row style="margin: 20px; padding: 0 6rem;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><i class="el-icon-coin" @click="toCase" style="cursor: pointer"> 案例库</i></el-breadcrumb-item>
        <el-breadcrumb-item><i class="el-icon-s-data"></i> {{caseItem.label}}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-container style="margin: 10px; padding: 0 3%;">
      <el-aside :style="{'width':'290px','minHeight':'40px','overflowY':'hidden', 'padding':'15px 0 0 0'}">
        <el-menu default-active="" class="el-menu-vertical-demo" @select="handleOpen" :collapse="isCollapse"
                 style="height:100%; margin-top: 10px;border-right: 0;" active-text-color='rgb(42, 165, 94)'>
          <el-menu-item :index="String(index)" v-for="(item,index) in leftMenus" :key="index" class="nav" @click='changeCard(item)'>
            <template slot="title">
              <i class="el-icon-document"></i>
              <span slot="title" style="font-size: 16px; font-weight: 500;line-height:20px;white-space: pre-wrap;display: inline-block;vertical-align: middle;">{{ item.title }}</span>
              <!-- <el-tooltip class="item" effect="dark" :content="item.title" placement="right-end"  slot="title">
                <span style="font-size: 16px; font-weight: 500;width: 150px;overflow: hidden;display: inline-block;white-space: nowrap;text-overflow: ellipsis;">{{ item.title }}</span>
              </el-tooltip> -->
            </template>
</el-menu-item>
</el-menu>
</el-aside>
<el-main v-loading="loading">
    <el-card v-if="detailInfo">
        <div class="article_item">
            <h3 style="text-align: center; font-size: 28px; line-height: 50px; color: #016f6f;"> {{ detailInfo['title'] }}</h3>
            <div class="sub_title"><span class="sub_year">{{'时间：'+detailInfo['year']}}</span><span class="sub_region">{{'地方：'+ detailInfo['region']}}</span></div>
            <img src="@/assets/images/divider.png" style="margin-top: 30px;" />
            <div v-html="detailInfo.content" class="article_item_content"></div>
            <!-- <img :src="detailInfo['pics']" alt="" v-if="detailInfo['pics']" class="sub_img"> -->
            <h3 v-if="detailInfo['pics']!=''"><i class="el-icon-caret-right"></i> 案例截图</h3>
            <div class="img_box" v-for="(item,index) in detailInfo['pics']" v-if="detailInfo['pics']!=''" :key="index">
                <el-image style="object-fit: contain;" :src="item" :preview-src-list="detailInfo['pics']"></el-image>
            </div>

            </el-image>
            <!--            <p v-if="detailInfo['pics']">{{'案例截图'}}</p>-->
        </div>
    </el-card>
    <div v-else>
        <div class="el-empty__image"><svg viewBox="0 0 79 86" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="linearGradient-1-4" x1="38.8503086%" y1="0%" x2="61.1496914%" y2="100%"><stop stop-color="#FCFCFD" offset="0%"></stop><stop stop-color="#EEEFF3" offset="100%"></stop></linearGradient><linearGradient id="linearGradient-2-4" x1="0%" y1="9.5%" x2="100%" y2="90.5%"><stop stop-color="#FCFCFD" offset="0%"></stop><stop stop-color="#E9EBEF" offset="100%"></stop></linearGradient><rect id="path-3-4" x="0" y="0" width="17" height="36"></rect></defs><g id="Illustrations" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="B-type" transform="translate(-1268.000000, -535.000000)"><g id="Group-2" transform="translate(1268.000000, 535.000000)"><path id="Oval-Copy-2" d="M39.5,86 C61.3152476,86 79,83.9106622 79,81.3333333 C79,78.7560045 57.3152476,78 35.5,78 C13.6847524,78 0,78.7560045 0,81.3333333 C0,83.9106622 17.6847524,86 39.5,86 Z" fill="#F7F8FC"></path><polygon id="Rectangle-Copy-14" fill="#E5E7E9" transform="translate(27.500000, 51.500000) scale(1, -1) translate(-27.500000, -51.500000) " points="13 58 53 58 42 45 2 45"></polygon><g id="Group-Copy" transform="translate(34.500000, 31.500000) scale(-1, 1) rotate(-25.000000) translate(-34.500000, -31.500000) translate(7.000000, 10.000000)"><polygon id="Rectangle-Copy-10" fill="#E5E7E9" transform="translate(11.500000, 5.000000) scale(1, -1) translate(-11.500000, -5.000000) " points="2.84078316e-14 3 18 3 23 7 5 7"></polygon><polygon id="Rectangle-Copy-11" fill="#EDEEF2" points="-3.69149156e-15 7 38 7 38 43 -3.69149156e-15 43"></polygon><rect id="Rectangle-Copy-12" fill="url(#linearGradient-1-4)" transform="translate(46.500000, 25.000000) scale(-1, 1) translate(-46.500000, -25.000000) " x="38" y="7" width="17" height="36"></rect><polygon id="Rectangle-Copy-13" fill="#F8F9FB" transform="translate(39.500000, 3.500000) scale(-1, 1) translate(-39.500000, -3.500000) " points="24 7 41 7 55 -3.63806207e-12 38 -3.63806207e-12"></polygon></g><rect id="Rectangle-Copy-15" fill="url(#linearGradient-2-4)" x="13" y="45" width="40" height="36"></rect><g id="Rectangle-Copy-17" transform="translate(53.000000, 45.000000)"><mask id="mask-4-4" fill="white"><use xlink:href="#path-3-4"></use></mask><use id="Mask" fill="#E0E3E9" transform="translate(8.500000, 18.000000) scale(-1, 1) translate(-8.500000, -18.000000) " xlink:href="#path-3-4"></use><polygon id="Rectangle-Copy" fill="#D5D7DE" mask="url(#mask-4-4)" transform="translate(12.000000, 9.000000) scale(-1, 1) translate(-12.000000, -9.000000) " points="7 0 24 0 20 18 -1.70530257e-13 16"></polygon></g><polygon id="Rectangle-Copy-18" fill="#F8F9FB" transform="translate(66.000000, 51.500000) scale(-1, 1) translate(-66.000000, -51.500000) " points="62 45 79 45 70 58 53 58"></polygon></g></g></g></svg></div>
        <p class="empty_text">暂无数据</p>
    </div>
</el-main>
</el-container>
<el-backtop target=""></el-backtop>
</div>
</template>
<script>
    import {
        getList,
        getTags,
        categoryCase
    } from '@/api/case'

    export default {
        props: {
            caseItem: {
                type: Object,
                default: () => {}
            },
            region: {
                type: String,
                default: () => 'pro'
            }
        },

        computed: {
            menus() {
                return this.$store.state.caseMenus
            }
        },
        data() {
            return {
                leftMenus: [],
                isCollapse: false,
                articleList: [],
                scroll: '',
                timer: null,
                detailInfo: {},
                loading: true
            }
        },
        watch: {
            scroll: function() {
                this.dataScroll()
            }
        },
        created() {
            this.init('')
                // this.getMenus()
            console.log(this.caseItem)
        },
        mounted() {
            window.addEventListener('scroll', this.dataScroll)
        },
        methods: {
            toCase() {
                this.$emit('closeDetail')
            },
            changeCard(item) {
                this.init(item.caseId)
            },
            init(id) {
                let me = this
                this.loading = true
                categoryCase(this.caseItem['val'], id).then(res => {
                    if (res.retCode === 0) {
                        setTimeout(() => {
                                me.loading = false
                            }, 200)
                            // me.loading = false
                        me.articleList = res.data
                        me.leftMenus = res.data.caseInfos
                        me.detailInfo = res.data.detail
                        me.detailInfo['pics'] = res.data.detail['pics'].split(';')
                    }
                    console.log(res)
                })
            },
            getMenus() {
                let obj = {
                    region: this.region
                }
                let me = this
                let arr = []
                getTags(this.caseItem['tagId'], obj).then(res => {
                    if (res.retCode === 0) {
                        me.leftMenus = res.data
                        for (let i of res.data) {
                            arr.push(i['tagId'])
                        }
                        me.init(arr)
                    }
                })
            },
            handleOpen(key, keyPath) {
                // console.log(key, keyPath);
                // this.jump(key)
            },
            jump(index) {
                // console.log(123)
                let jump = document.getElementsByClassName('article_item')
                    // 获取需要滚动的距离
                let total = jump[index].offsetTop
                    // console.log(total, 22)
                    // Chrome
                let step = 10

                this.timer = setInterval(() => {
                    step += 40
                    document.documentElement.scrollTop = document.body.scrollTop = step - 80
                    if (step >= total) {
                        clearInterval(this.timer)
                    }
                }, 10)
                window.pageYOffset = total
            },
            dataScroll: function() {
                this.scroll = document.documentElement.scrollTop || document.body.scrollTop
            }

        }
    }
</script>
<style>
    .case_detail .el-icon-arrow-down:before {
        content: 'transparent' !important;
        display: none;
    }
    
    .case_detail .el-menu {
        /* background-color: rgb(238, 238, 238) !important; */
        /* margin-top: 40px; */
    }
    
    .case_detail .el-aside {
        padding-top: 40px;
        /* background-color: rgb(238, 238, 238); */
        /* background: rgb(238, 238, 238); */
    }
    
    .case_detail .el-icon-arrow-left {
        font-size: 20px;
        vertical-align: text-bottom;
        margin-right: 5px;
        margin-left: 20px;
        font-weight: 600;
        cursor: pointer;
    }
    
    .el-menu-item,
    .el-submenu__title {
        /* line-height: 10px; */
    }
</style>
<style scoped>
    .img_box {
        width: 300px;
        height: 300px;
        float: left;
        box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
        border: 1px solid #ebeef5;
        border-radius: 10px;
        margin-right: 20px;
        margin-bottom: 20px;
        overflow: hidden;
    }
    /* .img_box img {
        width: auto;
        height: auto;
    } */
    
    .article_item {
        background: #fff;
        text-align: center;
        border-radius: 4px;
        padding: 0 25px;
        min-height: 500px;
    }
    
    .el-empty__image {
        width: 160px;
        margin: 0 auto;
        margin-top: 15%;
        display: block;
    }
    
    .empty_text {
        font-size: 14px;
        color: #5e6d82;
        line-height: 1.5em;
        text-align: center;
    }
    
    .sub_title {
        color: #999;
        font-size: 12px;
    }
    
    .sub_img {
        width: 400px;
        height: auto;
        margin-top: 20px;
    }
    
    .sub_title span {
        display: inline-block;
        width: 20%;
        text-align: left;
        text-indent: 20px;
    }
    
    .article_item_year {
        font-size: 12px;
        color: #666;
        margin-top: -30px;
    }
    
    .article_item h3 {
        color: #009844;
        width: 100%;
        font-size: 22px;
        line-height: 55px;
        text-align: left;
    }
    
    .article_item_content {
        line-height: 34px;
        text-align: left;
        padding-bottom: 15px;
        margin-top: 18px;
        font-size: 16px;
    }
    /* .current{

} */
</style>


// WEBPACK FOOTER //
// src/pages/casePage/components/caseDetail.vue